import { Component, Element, h, Prop } from '@stencil/core';
import { generateCssClasses } from '../../utils/generate-css-classes';
import { ZdsPopout } from '../zds-popout/zds-popout';

@Component({
	shadow: true,
	tag: 'zds-tooltip',
	styleUrl: 'zds-tooltip.scss',
})
export class ZdsTooltip {
	@Element() hostElement: HTMLElement;

	@Prop() alignment: 'start' | 'end' | 'center' = 'center';
	@Prop() arrow: boolean = false;
	@Prop() hoverDelay: number = 100;
	@Prop() target: ZdsPopout['target'];
	@Prop() placement: 'left' | 'right' | 'top' | 'bottom' = 'bottom';
	@Prop() theme: 'light' | 'dark' = 'dark';
	@Prop() trigger: 'hover' | 'click' = 'hover';
	@Prop() offsetX: number = 10;
	@Prop() offsetY: number = 0;
	@Prop() maxWidth: number | string = 300;
	@Prop() strategy: 'absolute' | 'fixed' = 'absolute';

	render() {
		const cssClasses = generateCssClasses('zds-tooltip', {
			dark: this.theme === 'dark',
		});

		return (
			<div class={cssClasses}>
				<zds-popout
					animation="grow"
					arrow={this.arrow}
					hoverDelay={this.hoverDelay}
					target={this.target}
					trigger={this.trigger}
					position={this.alignment}
					placement={this.placement}
					maxWidth={this.maxWidth}
					offsetMain={this.offsetX}
					offsetCross={this.offsetY}
					alwaysComputePosition
					strategy={this.strategy}
				>
					<div class="zds-tooltip__content">
						<slot />
					</div>
				</zds-popout>
			</div>
		);
	}
}
